import { FunctionComponent, useRef, useState } from "react";

import { Button } from "@/components/Button/Button";
import { ButtonSize } from "@/components/Button/types";

interface RowRetryButtonProps {
	title: string;
	onRetry: () => void | Promise<void>;
}

/**
 * The Reason column's Retry (PREC-4520): disabled while its request runs, so a double click sends
 * one request and the user sees one answer, not two contradicting snackbars. The ref guards the
 * click that lands before React has re-rendered the button disabled.
 */
export const RowRetryButton: FunctionComponent<RowRetryButtonProps> = ({ title, onRetry }) => {
	const [pending, setPending] = useState(false);
	const pendingRef = useRef(false);

	const handleClick = async () => {
		if (pendingRef.current) {
			return;
		}

		pendingRef.current = true;
		setPending(true);

		try {
			await onRetry();
		} finally {
			pendingRef.current = false;
			setPending(false);
		}
	};

	return (
		<Button
			className="!h-[24px] !w-fit whitespace-nowrap !px-2 !text-xs"
			disabled={pending}
			size={ButtonSize.XS}
			testId="row-retry"
			title={title}
			onClick={(event) => {
				event.stopPropagation();
				void handleClick();
			}}
		/>
	);
};
